<template>
  <div class="ap">

    <!-- ════════════════════ HEADER CARD ════════════════════ -->
    <div class="ap-dash-header">
      <div class="ap-dash-header-top">
        <div>
          <div class="ap-eyebrow">MARKETING · AUTOMATION ENGINE</div>
          <h1 class="ap-title">Automatizaciones de plataforma</h1>
        </div>
        <div class="ap-header-actions">
          <div class="ap-stat-pill" v-if="plataformaSeleccionada === 'youtube'">
            <i class="fa-brands fa-youtube"></i>
            <strong>{{ formartedItems ? formartedItems.length : 0 }}</strong>
            <span>búsquedas activas</span>
          </div>
          <div class="ap-stat-pill" v-else-if="plataformaSeleccionada === 'google'">
            <i class="fa-brands fa-google"></i>
            <strong>{{ formartedItemsGoogle ? formartedItemsGoogle.length : 0 }}</strong>
            <span>búsquedas activas</span>
          </div>
        </div>
      </div>

      <!-- ════ Platform tabs (segmented) ════ -->
      <div class="ap-platforms">
        <button
          type="button"
          class="ap-platform"
          :class="{ 'is-active': plataformaSeleccionada === 'youtube' }"
          @click="plataformaSeleccionada = 'youtube'"
        >
          <i class="fa-brands fa-youtube" style="color: #FF0000;"></i>
          <span>YouTube</span>
        </button>
        <button type="button" class="ap-platform is-disabled" disabled>
          <i class="fa-brands fa-instagram"></i>
          <span>Instagram</span>
          <span class="ap-platform-soon">SOON</span>
        </button>
        <button
          type="button"
          class="ap-platform"
          :class="{ 'is-active': plataformaSeleccionada === 'google' }"
          @click="plataformaSeleccionada = 'google'"
        >
          <i class="fa-brands fa-google" style="color: #4285F4;"></i>
          <span>Google</span>
        </button>
        <button type="button" class="ap-platform is-disabled" disabled>
          <i class="fa-brands fa-tiktok"></i>
          <span>TikTok</span>
          <span class="ap-platform-soon">SOON</span>
        </button>
      </div>
    </div>

    <b-card-code :title="titleHeaderBusquedasMasivas" v-if="fullAutomatizaciones && plataformaSeleccionada == 'youtube'">
      <h4 v-if="nuevosVideosEncontrados > 0">Videos nuevos encontrados: {{ nuevosVideosEncontrados }}</h4>
        <b-row class="match-height">
          
          <b-col md="2">
            <b-form-group label="Cantidad por busqueda" label-for="unidades">
              <b-form-input id="unidades" type="number" placeholder="Texto a buscar" v-model="cantidadPorBusqueda" @wheel.prevent />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Pais" label-for="v-pais">
              <v-select
                v-model="paisMasiva"
                class="sku-select"
                label="name"
                :options="paises"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Idioma" label-for="v-idioma">
              <v-select
                v-model="idiomaMasiva"
                class="sku-select"
                label="name"
                :options="idiomas"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Fecha" label-for="v-fecha">
              <v-select
                v-model="fechaMasiva"
                class="sku-select"
                label="name"
                :options="listaRelevante"
              />
            </b-form-group>
          </b-col>          
        </b-row>

        <b-button 
            variant="primary" 
            style="margin-right: 10px; margin-bottom: 10px;"
            @click="lanzarBusquedaMaximaYoutube()"
          >
            Lanzar automatizaciones
          </b-button>
      </b-card-code>

      <b-card-code :title="titleHeaderBusquedasMasivasGoogle" v-if="fullAutomatizaciones && plataformaSeleccionada == 'google'">
      <h4 v-if="nuevosBusquedasdGoogleEncontradas > 0">Webs nuevas encontradas: {{ nuevosBusquedasdGoogleEncontradas }}</h4>
        <b-row class="match-height">
          
          <b-col md="2">
            <b-form-group label="Cantidad por busqueda" label-for="unidades">
              <b-form-input id="unidades" type="number" placeholder="Texto a buscar" v-model="cantidadPorBusqueda" @wheel.prevent/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Pais" label-for="v-pais">
              <v-select
                v-model="paisMasiva"
                class="sku-select"
                label="name"
                :options="paises"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Idioma" label-for="v-idioma">
              <v-select
                v-model="idiomaMasiva"
                class="sku-select"
                label="name"
                :options="idiomas"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Fecha" label-for="v-fecha">
              <v-select
                v-model="fechaMasiva"
                class="sku-select"
                label="name"
                :options="listaRelevante"
              />
            </b-form-group>
          </b-col>          
        </b-row>

        <b-row class="match-height">
          <b-col cols="10">


              <b-form-file
              v-model="csvInputAhref"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            />
          </b-col>

          <b-col cols="2">
            <b-button 
              variant="primary" 
              style="margin-right: 10px; margin-bottom: 10px;"
              @click="procesarAhref()"
            >
              Procesar Ahref csv
            </b-button>
          </b-col>

        </b-row>

      <br>
          <b-button 
            variant="primary" 
            style="margin-right: 10px; margin-bottom: 10px;"
            @click="lanzarBusquedaMaximaGoogle()"
          >
            Lanzar google
          </b-button>

          <b-button             
            variant="primary" 
            style="margin-right: 10px; margin-bottom: 10px;"
            @click="lanzaHref()"
          >
            Lanzar href
          </b-button>

      </b-card-code>


      <b-card-code title="Youtube busquedas" v-if="plataformaSeleccionada == 'youtube'">
        <b-row class="match-height">
          <b-col md="4">
            <b-form-group label="Buscador Youtube" label-for="unidades">
              <b-form-input id="unidades" type="text" placeholder="Texto a buscar" v-model="texto" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Pais" label-for="v-pais">
              <v-select
                v-model="paisSelected"
                class="sku-select"
                label="name"
                :options="paises"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Idioma" label-for="v-idioma">
              <v-select
                v-model="idiomaSelected"
                class="sku-select"
                label="name"
                :options="idiomas"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Fecha" label-for="v-fecha">
              <v-select
                v-model="relevanteSelected"
                class="sku-select"
                label="name"
                :options="listaRelevante"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Frecuencia de busqueda" label-for="v-frecuencia">
              <v-select
                v-model="frecuenciaSelected"
                class="sku-select"
                label="name"
                :options="listaFrecuencia"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-button 
            variant="primary" 
            style="margin-right: 10px; margin-bottom: 10px;"
            @click="crearYoutube()"
          >
            Crear busqueda
          </b-button>

      </b-card-code>

      <b-card-code title="Listado Youtube busquedas" v-if="plataformaSeleccionada == 'youtube'">
        <b-table
              :items="formartedItems"
              :fields="columnasTableYoutubeBusquedas"
              class="table table-borderless table-prevision"
              no-border-collapse
              sort-icon-left
              striped 
              ref="tableProduccion"
            >

            <template #cell(play)="data">
              <i @click="lanzarBusqueda(data.item)" class="fa-solid fa-circle-play btn-span"></i>              
            </template>

            <template #cell(options)="data">
              <b-button v-b-tooltip.hover.top="'Borrar'" @click="borrarBusqueda(data.item)" variant="outline-danger" class="btn-circle"><i class="fa-solid fa-trash"></i></b-button>
            </template>
  
          </b-table>
      </b-card-code>

      <b-card-code title="Google búsquedas" v-if="plataformaSeleccionada == 'google'">
        <b-row class="match-height">
          <b-col md="4">
            <b-form-group label="Buscador Google" label-for="google-texto">
              <b-form-input id="google-texto" type="text" placeholder="Texto a buscar" v-model="texto" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="País" label-for="google-pais">
              <v-select
                v-model="paisSelected"
                class="sku-select"
                label="name"
                :options="paises"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Idioma" label-for="google-idioma">
              <v-select
                v-model="idiomaSelected"
                class="sku-select"
                label="name"
                :options="idiomas"
              />
            </b-form-group>
          </b-col>          
        </b-row>

        <b-button 
          variant="primary" 
          style="margin-right: 10px; margin-bottom: 10px;"
          @click="crearGoogle()"
        >
          Crear búsqueda
        </b-button>
      </b-card-code>

      <b-card-code title="Listado Google búsquedas" v-if="plataformaSeleccionada == 'google'">
        <b-table
          :items="formartedItemsGoogle"
          :fields="columnasTableGoogleBusquedas"
          class="table table-borderless table-prevision"
          no-border-collapse
          sort-icon-left
          striped
          ref="tableGoogle"
        >
          <template #cell(play)="data">
            <i style="color: #4285f4;" @click="lanzarBusquedaGoogle(data.item)" class="fa-brands fa-google btn-span"></i>
          </template>

          <template #cell(options)="data">
            <b-button v-b-tooltip.hover.top="'Borrar'" @click="borrarBusquedaGoogle(data.item)" variant="outline-danger" class="btn-circle">
              <i class="fa-solid fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </b-card-code>


      <b-modal
        id="modal-youtube"
        title="Youtube busqueda"
        centered
        size="xl"
        hide-footer
        >             
        <div class="video-list">
          <div v-for="video in pruebaDatosYoutube" :key="video.videoId" class="video-card">
            <a :href="video.videoUrl" target="_blank">
              <img :src="video.videoFoto" :alt="video.videoTitulo" class="thumbnail" />
            </a>
            <div class="video-info">
              <h3>
                <a :href="video.videoUrl" target="_blank">{{ video.videoTitulo }}</a>
              </h3>
              <p>Canal: <a :href="video.canalUrl" target="_blank">{{ video.canalTitulo }}</a></p>
              <p>País: {{ video.canalPais }}</p>
              <p>Vistas: {{ video.videoVisitas }}</p>
              <p>Suscriptores: {{ video.canalSubscriptores }}</p>
              <p>Publicado: {{ new Date(video.videoFecha).toLocaleDateString() }}</p>
            </div>
          </div>
        </div>
    </b-modal>
  </div>
</template>
  
  
  <script>
  import axios from '@axios'
  import vSelect from 'vue-select'
  import BCardCode from '@core/components/b-card-code'
  import { BRow, BCol, BFormFile, BButton  } from 'bootstrap-vue'
  import { BTable } from 'bootstrap-vue'
  
  import paises from '../../libs/paisesYoutube';
  import idiomas from '../../libs/idiomasYoutube';
  
  export default {
  
    components: {
          BCardCode,
          BRow,
          BCol,
          BFormFile,
          BButton,
          vSelect,
          BTable
      },
    data(){
      return{
        paises: paises,
        paisSelected: "",
        idiomas: idiomas,
        idiomaSelected: "",
        listaRelevante: [  { code: "relevante", name: "Relevante" },{ code: "Ultima semana", name: "Ultima semana" },{ code: "Ultimo mes", name: "Ultimo mes" },{ code: "Ultimo año", name: "Ultimo año" }],
        relevanteSelected: "",
        listaFrecuencia: [  { code: "Diaria", name: "Diaria" },{ code: "3 Dias", name: "3 Dias" },{ code: "Semanal", name: "Semanal" },{ code: "2 semanas", name: "2 semanas" },{ code: "Mensual", name: "Mensual" }],
        frecuenciaSelected: "",
        texto: "",
        unidades: "",
        fechaInicio: "",
        fechaFin: "",
        dias: "",
        listaBusquedasYoutube: [],
        listaBusquedasGoogle: [],
        columnasTableYoutubeBusquedas: [
          {
            key: "play",
            label: "",
            thStyle: { width: "5%" },
          },
          {
            key: "texto",
            label: "Texto",
            sortable: true,
          },{
            key: "paisNombre",
            label: "Pais",
            sortable: true,
          },{
            key: "idiomaNombre",
            label: "Idioma",
            sortable: true,
          },
          {
            key: "relevante",
            label: "Fecha",
            sortable: true,
          },
          {
            key: "frecuencia",
            label: "Frecuencia",
            sortable: true,
          },
          {
            key: "options",
            label: "",
            thStyle: { width: "5%" },
          },

        ],
        pruebaDatosYoutube: [
          {
            "videoTitulo": "Fui a Apple y compré fundas para el nuevo iPhone 16e #tecnologia #tech #iphone #apple #challenge",
            "videoId": "CQXCmNUo5IM",
            "videoVisitas": "41526",
            "videoFecha": "2025-03-28T01:36:04Z",
            "videoUrl": "https://www.youtube.com/watch?v=CQXCmNUo5IM",
            "videoFoto": "https://i.ytimg.com/vi/CQXCmNUo5IM/hqdefault.jpg",
            "canalTitulo": "Sami Pec",
            "canalUrl": "https://www.youtube.com/channel/UCgeu38G_jcXQ1xMiRZgD_AA",
            "canalPais": "MX",
            "canalFoto": "https://yt3.ggpht.com/Ev8be2ewybN44C-icTao59Bz_iUgKa0VYVNg21KVHY8bea-sFXFcedU4JZEzf_5IOidLz14t1w=s800-c-k-c0x00ffffff-no-rj",
            "canalSubscriptores": "990000",
          }
        ],
        columnasTableGoogleBusquedas: [
          {
            key: "play",
            label: "",
            thStyle: { width: "5%" },
          },
          {
            key: "texto",
            label: "Texto",
            sortable: true,
          },{
            key: "paisNombre",
            label: "Pais",
            sortable: true,
          },{
            key: "idiomaNombre",
            label: "Idioma",
            sortable: true,
          },          
          {
            key: "options",
            label: "",
            thStyle: { width: "5%" },
          },

        ],
        fullAutomatizaciones: false,
        paisMasiva: "",
        idiomaMasiva: "",
        fechaMasiva: "",
        cantidadPorBusqueda: 20,
        titleHeaderBusquedasMasivas: "Youtube busquedas masivas: ",
        cantidadBusquedasMasivasCompletadas: 0,
        nuevosVideosEncontrados: 0,
        titleHeaderBusquedasMasivasGoogle: "Google busquedas masivas: ",
        cantidadBusquedasMasivasCompletadasGoogle: 0,        
        nuevosBusquedasdGoogleEncontradas: 0,
        plataformaSeleccionada: "google",
        googleWebsSinDatos: [],
        cantidadAhrefLanzada: 0,
        csvInputAhref: null
      }
    },
    methods:{
      async loadItems(){
        axios.post("/uso", {seccion:"automatizaciones-plataformas"});

        const responseReportes = await axios.get("/seo/youtube/busqueda");
        this.listaBusquedasYoutube = responseReportes.data;

        this.titleHeaderBusquedasMasivas = "Youtube busquedas masivas: 0/" + this.listaBusquedasYoutube.length;

        const responseReportesGoogle = await axios.get("/seo/google/busqueda");
        this.listaBusquedasGoogle = responseReportesGoogle.data;

        this.titleHeaderBusquedasMasivasGoogle = "Google busquedas masivas: 0/" + this.listaBusquedasGoogle.length;

        const responseReportesWeb = await axios.get("/seo/google/webs");
        this.googleWebsSinDatos = responseReportesWeb.data;       
      },
      crearYoutube(){
        let info = {
          texto: this.texto,
          pais: this.paisSelected?.code || '',
          idioma: this.idiomaSelected?.code || '',
          relevante: this.relevanteSelected?.code || 'Relevante',
          frecuencia: this.frecuenciaSelected?.code || 'Diaria'
        };

          axios
            .post("/seo/youtube/busqueda", info)
            .then(response => {
                return response.data;
            })
            .then(res => {
              info.id = res.insertId;
              this.listaBusquedasYoutube.push(info);
            });
      },
      crearGoogle(){
        let info = {
          texto: this.texto,
          pais: this.paisSelected?.code || '',
          idioma: this.idiomaSelected?.code || '',        
        };

          axios
            .post("/seo/google/busqueda", info)
            .then(response => {
                return response.data;
            })
            .then(res => {
              info.id = res.insertId;
              this.listaBusquedasGoogle.push(info);
            });
      },
      lanzarBusqueda(item){
        
        let info = {busquedaid: item.id, texto: item.texto, pais: item.pais, idioma: item.idioma, fecha: item.relevante}

        axios
            .post("/seo/youtube/buscar", info)
            .then(response => {
                return response.data;
            })
            .then(res => {
              this.pruebaDatosYoutube = res.videos;

              this.$bvModal.show('modal-youtube');
            });
      },
      async lanzarBusquedaGoogle(item){

        const info = {
            busquedaid: item.id,
            texto: item.texto,
            pais: item.pais || '',
            idioma: item.idioma || '',
          };

          const response = await axios.post("/seo/google/buscar/masiva", info);
          const res = response.data;

          //console.log(res);
      },      
      async lanzarBusquedaMaximaGoogle() {

        this.cantidadBusquedasMasivasCompletadasGoogle = 0;
        this.nuevosBusquedasdGoogleEncontradas = 0;

        for (const item of this.listaBusquedasGoogle) {
          const info = {
            busquedaid: item.id,
            texto: item.texto,
            pais: this.paisMasiva?.code || item.pais || '',
            idioma: this.idiomaMasiva?.code || item.idioma || '',
            cantidad: this.cantidadPorBusqueda,
          };

          try {
            const response = await axios.post("/seo/google/buscar/masiva", info);
            const res = response.data;

            this.cantidadBusquedasMasivasCompletadasGoogle++;
            this.titleHeaderBusquedasMasivasGoogle = "Google busquedas masivas: " + this.cantidadBusquedasMasivasCompletadasGoogle + "/" + this.listaBusquedasGoogle.length;     
            this.nuevosBusquedasdGoogleEncontradas += res.totalNuevos;
          } catch (error) {
            console.error("Error al hacer la petición:" + info.texto, error);
          }
        }

        
       
        /*const response = await axios.post("/seo/google/buscar/masiva", {texto:this.texto, busquedaid: 0});
        const res = response.data;
        

        res.resultados.forEach(element => {
          console.log(element.enlace);
        });

        console.log(res.resultados);*/
        
      },
      lanzaHref(){

        const urls = this.googleWebsSinDatos.map(item => `https://app.ahrefs.com/v2-site-explorer/overview?target=${item.url}`);
  
        if (!this.cantidadAhrefLanzada) this.cantidadAhrefLanzada = 0;

        const batch = urls.slice(this.cantidadAhrefLanzada, this.cantidadAhrefLanzada + 30);

        let i = 0;

        const abrirSiguiente = () => {
          if (i < batch.length) {
            window.open(batch[i], '_blank');
            i++;
            this.cantidadAhrefLanzada++;
            setTimeout(abrirSiguiente, 1000)
          } else {
            if (this.cantidadAhrefLanzada >= urls.length) {
              console.log('✅ Ya se lanzaron todas las URLs.');
            } else {
              console.log(`🔁 Lanzadas: ${this.cantidadAhrefLanzada} / ${urls.length}`);
            }
          }
        };

        abrirSiguiente();
      },
      procesarAhref() {
        const reader = new FileReader();

        reader.onload = (e) => {
          const lines = reader.result.split(/\r?\n/);
          const dataExport = [];

          // Ignora encabezado
          for (let i = 1; i < lines.length; i++) {
            const line = lines[i].trim();
            if (line) {
              const [domain, dr, traffic] = line.split(',');

              // Busca el ID correspondiente por URL en googleWebsSinDatos
              const match = this.googleWebsSinDatos.find(item => 
                item.url.trim().toLowerCase() === domain.trim().toLowerCase()
              );

              if (match) {
                dataExport.push({
                  id: match.id,
                  url: match.url,
                  dr: dr.trim(),
                  traffic: traffic.trim()
                });
              } else {
                console.warn(`⚠️ No se encontró coincidencia para: ${domain}`);
              }
            }
          }

          const payload = { registros: dataExport };

          axios.post('/seo/google/ahrefs', payload)
            .then(() => {
              this.$bvToast.toast('✅ Se ha guardado el CSV en la base de datos correctamente', {
                title: 'Ahrefs',
                variant: 'success',
                solid: true,
              });
            })
            .catch((error) => {
              console.error('❌ Error al guardar en la base de datos:', error);
              this.$bvToast.toast('❌ Error al guardar el CSV en la base de datos', {
                title: 'Ahrefs',
                variant: 'danger',
                solid: true,
              });
            });
        };

        reader.readAsText(this.csvInputAhref); // Asegúrate que el input es un archivo Blob
      },

      async lanzarBusquedaMaximaYoutube() {
        this.cantidadBusquedasMasivasCompletadas = 0;
        this.nuevosVideosEncontrados = 0;

        for (const item of this.listaBusquedasYoutube) {
          const info = {
            busquedaid: item.id,
            texto: item.texto,
            pais: this.paisMasiva?.code || '',
            idioma: this.idiomaMasiva?.code || '',
            fecha: this.fechaMasiva?.code || 'Relevante',
            cantidad: this.cantidadPorBusqueda,
          };

          try {
            const response = await axios.post("/seo/youtube/buscar/masiva", info);
            const res = response.data;
            this.cantidadBusquedasMasivasCompletadas++;
            this.titleHeaderBusquedasMasivas = "Youtube busquedas masivas: " + this.cantidadBusquedasMasivasCompletadas + "/" + this.listaBusquedasYoutube.length;     
            this.nuevosVideosEncontrados += res.totalNuevos;
          } catch (error) {
            console.error("Error al hacer la petición:" + info.texto, error);
          }
        }
      },
      borrarBusqueda(item){
        axios
            .delete("/seo/youtube/busqueda/"+item.id)
            .then(response => {
                return response.data;
            })
            .then(res => {              
              this.listaBusquedasYoutube = this.listaBusquedasYoutube.filter(data => data.id != item.id);
            });
      },
      borrarBusquedaGoogle(item){
        axios
            .delete("/seo/google/busqueda/"+item.id)
            .then(response => {
                return response.data;
            })
            .then(res => {              
              this.listaBusquedasGoogle = this.listaBusquedasGoogle.filter(data => data.id != item.id);
            });
      }
    },
    mounted() {
      this.fullAutomatizaciones = this.$route.params.id !== undefined;
      this.loadItems();
    }, 
    computed: {
      formartedItems () {
        return this.listaBusquedasYoutube.map(item => {
            const paisNombre = paises.find(p => p.code === item.pais)?.name || item.pais;
            const idiomaNombre = idiomas.find(i => i.code === item.idioma)?.name || item.idioma;

            return {
              ...item,
              paisNombre,
              idiomaNombre
            };
          })
      },
      formartedItemsGoogle () {
        return this.listaBusquedasGoogle.map(item => {
            const paisNombre = paises.find(p => p.code === item.pais)?.name || item.pais;
            const idiomaNombre = idiomas.find(i => i.code === item.idioma)?.name || item.idioma;

            return {
              ...item,
              paisNombre,
              idiomaNombre
            };
          })
      }

    },
  }
  </script>

  <style lang="scss">
    @import '../@core/scss/vue/libs/vue-select.scss';

    .btn-span:hover{
      cursor: pointer;
    }

    .btn-span{
      color: rgb(212, 89, 89);
    }
  </style>

<style scoped>
.video-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}
.video-card {
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}
.thumbnail {
  width: 100%;
  border-radius: 8px;
}
.video-info {
  margin-top: 10px;
}
.video-info h3 {
  font-size: 16px;
}
.video-info p {
  font-size: 14px;
  margin: 4px 0;
}
</style>

<style lang="scss">
    @import '../@core/scss/vue/libs/vue-select.scss';
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

    .btn-span:hover{
        cursor: pointer;
    }

    .btn-span{
        color: rgb(212, 89, 89);
    }
    .icon-brand{
        font-size: 100px;
    }
    .icon-click:hover{
        cursor: pointer;
    }
    .icon-noclick{
        cursor:  not-allowed;
    }

    // ══════════════════════════════════════════════════════════════
    // DATA-DENSE DASHBOARD — AUTOMATIZACIONES PLATAFORMA
    // Same tokens as /pedido-taller-vero/fabricando
    // ══════════════════════════════════════════════════════════════

    $ap-bg:        #F8FAFC;
    $ap-surface:   #FFFFFF;
    $ap-surface-2: #F1F5F9;
    $ap-border:    #E2E8F0;
    $ap-divider:   #EEF2F7;
    $ap-ink:       #1E293B;
    $ap-text:      #1E293B;
    $ap-mute:      #64748B;
    $ap-soft:      #94A3B8;
    $ap-primary:   #3B82F6;
    $ap-primary-soft: #60A5FA;
    $ap-cta:       #F97316;
    $ap-emerald:   #10B981;
    $ap-coral:     #EF4444;

    .ap {
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
      background: $ap-bg;
      color: $ap-text;
      margin: -2rem;
      padding: 28px 32px 56px;
      min-height: calc(100vh - 4rem);
      font-feature-settings: "tnum", "zero";

      *, *::before, *::after { box-sizing: border-box; }

      // ──────────── HEADER CARD ────────────
      .ap-dash-header {
        background: $ap-surface;
        border: 1px solid $ap-border;
        border-radius: 14px;
        padding: 18px 20px 14px;
        margin-bottom: 18px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
      }

      .ap-dash-header-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 16px;
        flex-wrap: wrap;
      }

      .ap-eyebrow {
        font-family: 'JetBrains Mono', monospace;
        font-size: 10px;
        font-weight: 600;
        color: $ap-primary;
        letter-spacing: 0.14em;
        margin-bottom: 4px;

        &::before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          background: $ap-cta;
          border-radius: 50%;
          margin-right: 6px;
          vertical-align: middle;
          animation: ap-pulse 2s infinite;
        }
      }

      .ap-title {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 22px;
        font-weight: 700;
        color: $ap-ink;
        line-height: 1.1;
        letter-spacing: -0.01em;
        margin: 0;
      }

      .ap-header-actions {
        display: flex;
        gap: 8px;
        align-items: center;
      }

      .ap-stat-pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 38px;
        padding: 0 14px;
        background: $ap-bg;
        border: 1px solid $ap-border;
        border-radius: 8px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 12px;
        font-weight: 500;
        color: $ap-mute;

        i { color: $ap-primary; font-size: 13px; }
        strong {
          font-family: 'JetBrains Mono', monospace;
          font-size: 13px;
          font-weight: 700;
          color: $ap-ink;
          font-feature-settings: "tnum";
        }
      }

      // ──────────── PLATFORM TABS ────────────
      .ap-platforms {
        display: flex;
        gap: 6px;
        background: $ap-bg;
        border: 1px solid $ap-border;
        border-radius: 10px;
        padding: 4px;
      }

      .ap-platform {
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 42px;
        padding: 0 16px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 8px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 13px;
        font-weight: 600;
        color: $ap-mute;
        cursor: pointer;
        transition: all 200ms ease;

        i { font-size: 16px; color: $ap-soft; }

        &:hover:not(.is-disabled) {
          color: $ap-ink;
          background: rgba(15, 23, 42, 0.03);
          i { color: $ap-mute; }
        }

        &.is-active {
          background: $ap-surface;
          color: $ap-ink;
          border-color: $ap-border;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
        }

        &.is-disabled {
          cursor: not-allowed;
          opacity: 0.4;
        }
      }

      .ap-platform-soon {
        font-family: 'JetBrains Mono', monospace;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.12em;
        background: rgba(15, 23, 42, 0.08);
        color: $ap-mute;
        padding: 2px 6px;
        border-radius: 4px;
      }

      // ──────────── B-CARD-CODE / B-CARD overrides ────────────
      .card,
      .b-card-code {
        background: $ap-surface !important;
        border: 1px solid $ap-border !important;
        border-radius: 14px !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        margin-bottom: 18px !important;

        .card-header {
          background: $ap-surface !important;
          border-bottom: 1px solid $ap-divider !important;
          padding: 16px 20px 14px !important;
          border-left: 0 !important;
          border-radius: 14px 14px 0 0 !important;

          // kill the b-card-code green pill bg + left accent
          &::before, &::after { display: none !important; }
        }
        .card-title {
          color: $ap-ink !important;
          font-family: 'Plus Jakarta Sans', sans-serif !important;
          font-weight: 700 !important;
          font-size: 18px !important;
          letter-spacing: -0.015em;
          background: transparent !important;
          border: 0 !important;
          border-left: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
          box-shadow: none !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px;
          line-height: 1.2;

          &::before {
            content: '›';
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-family: 'JetBrains Mono', monospace;
            font-size: 18px;
            font-weight: 800;
            color: $ap-primary;
            line-height: 1;
          }

          &::after { display: none !important; }
        }
        .card-body { padding: 20px !important; }

        h4 {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          color: $ap-emerald;
          background: rgba(16, 185, 129, 0.08);
          padding: 10px 14px;
          border-radius: 8px;
          border-left: 3px solid $ap-emerald;
          margin-bottom: 14px;
        }
      }

      // ──────────── FORM CONTROLS ────────────
      .form-group label,
      legend {
        font-family: 'JetBrains Mono', monospace !important;
        font-size: 10px !important;
        font-weight: 600 !important;
        color: $ap-soft !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        margin-bottom: 6px !important;
      }

      .form-control {
        background: $ap-surface !important;
        border: 1px solid $ap-border !important;
        border-radius: 8px !important;
        font-size: 13px !important;
        height: 38px !important;
        color: $ap-ink !important;
        transition: all 150ms ease !important;
        box-shadow: none !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;

        &::placeholder { color: $ap-soft; }
        &:focus {
          outline: none !important;
          border-color: $ap-primary !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
        }
      }

      // file input
      .custom-file {
        height: 38px !important;

        .custom-file-label {
          background: $ap-surface !important;
          border: 1px solid $ap-border !important;
          border-radius: 8px !important;
          color: $ap-ink !important;
          height: 38px !important;
          padding: 9px 14px !important;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;

          &::after {
            background: $ap-surface-2 !important;
            border-left: 1px solid $ap-border !important;
            color: $ap-text !important;
            font-weight: 600;
            border-radius: 0 8px 8px 0 !important;
          }
        }
      }

      // ──────────── V-SELECT ────────────
      .v-select {
        .vs__dropdown-toggle {
          background: $ap-surface !important;
          border: 1px solid $ap-border !important;
          border-radius: 8px !important;
          min-height: 38px;
          padding: 0 6px;
          box-shadow: none !important;
        }
        &.vs--open .vs__dropdown-toggle,
        .vs__dropdown-toggle:focus-within {
          border-color: $ap-primary !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
        }
        .vs__selected, .vs__search {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          color: $ap-ink;
          padding: 0 6px;
          line-height: 36px;
        }
        .vs__open-indicator { fill: $ap-soft; transform: scale(0.75); }
        .vs__dropdown-menu {
          background: $ap-surface;
          border: 1px solid $ap-border;
          border-radius: 8px;
          box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
          padding: 4px;
        }
        .vs__dropdown-option {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          color: $ap-text;
          padding: 8px 10px;
          border-radius: 6px;
          &--highlight { background: $ap-surface-2; color: $ap-primary; }
        }
      }

      // ──────────── BUTTONS ────────────
      .btn {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border-radius: 8px !important;
        padding: 8px 14px !important;
        transition: all 200ms ease !important;
        box-shadow: none !important;
        border-width: 1px !important;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;

        &.btn-sm {
          padding: 6px 10px !important;
          font-size: 11px !important;
          height: 32px;
        }

        &.btn-primary {
          background: $ap-primary !important;
          border-color: $ap-primary !important;
          color: #fff !important;
          &:hover:not(:disabled) {
            background: darken($ap-primary, 6%) !important;
            border-color: darken($ap-primary, 6%) !important;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25) !important;
          }
        }
        &.btn-success {
          background: $ap-emerald !important;
          border-color: $ap-emerald !important;
          color: #fff !important;
          &:hover:not(:disabled) { background: darken($ap-emerald, 6%) !important; border-color: darken($ap-emerald, 6%) !important; }
        }
        &.btn-danger {
          background: $ap-coral !important;
          border-color: $ap-coral !important;
          color: #fff !important;
          &:hover:not(:disabled) { background: darken($ap-coral, 6%) !important; border-color: darken($ap-coral, 6%) !important; }
        }
        &.btn-warning {
          background: $ap-cta !important;
          border-color: $ap-cta !important;
          color: #fff !important;
          &:hover:not(:disabled) { background: darken($ap-cta, 6%) !important; border-color: darken($ap-cta, 6%) !important; }
        }
        &.btn-outline-danger {
          background: transparent !important;
          border-color: $ap-border !important;
          color: $ap-coral !important;
          &:hover:not(:disabled) {
            background: rgba(239, 68, 68, 0.06) !important;
            border-color: $ap-coral !important;
          }
        }
      }

      .btn-circle {
        width: 32px !important;
        height: 32px !important;
        padding: 0 !important;
        border-radius: 50% !important;
        font-size: 11px !important;
      }

      // ──────────── B-TABLE ────────────
      .table {
        background: $ap-surface !important;
        margin-bottom: 0 !important;
        font-family: 'Plus Jakarta Sans', sans-serif;

        thead th {
          font-family: 'JetBrains Mono', monospace !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          color: $ap-soft !important;
          letter-spacing: 0.08em !important;
          text-transform: uppercase;
          background: $ap-surface !important;
          border-bottom: 1px solid $ap-border !important;
          border-top: 0 !important;
          padding: 13px 14px !important;
        }
        tbody tr {
          transition: background 150ms ease;
          background: $ap-surface !important;

          td {
            border-top: 1px solid $ap-divider !important;
            font-size: 13px;
            color: $ap-text !important;
            padding: 11px 14px !important;
            vertical-align: middle;
            background: transparent !important;
          }
          &:hover { background: rgba(59, 130, 246, 0.04) !important; }
          &:nth-of-type(odd) td { background: transparent !important; }
        }
      }

      .btn-span {
        cursor: pointer;
        color: $ap-primary !important;
        font-size: 18px;
        transition: all 150ms ease;

        &:hover { transform: scale(1.15); color: darken($ap-primary, 8%) !important; }
      }

      // ──────────── HIDE OLD ICONS ────────────
      .icon-brand { display: none !important; }

      // ──────────── ANIMATIONS ────────────
      @keyframes ap-pulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.55; transform: scale(0.85); }
      }

      @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
          animation-duration: 0.01ms !important;
          transition-duration: 0.01ms !important;
        }
      }
    }

    // ══════════ DARK MODE ══════════
    .dark-layout .ap {
      background: #161616;
      color: #d0d2d6;

      .ap-dash-header,
      .card, .b-card-code { background: #1f1f1f !important; border-color: #2c2c2c !important; }
      .ap-title { color: #e4e6eb; }
      .ap-stat-pill { background: #161616; border-color: #2c2c2c; }
      .ap-stat-pill strong { color: #e4e6eb; }

      .ap-platforms { background: #161616; border-color: #2c2c2c; }
      .ap-platform { color: #8e9099; }
      .ap-platform.is-active { background: #242424; border-color: #2c2c2c; color: #e4e6eb; }

      .form-control,
      .custom-file-label {
        background: #1f1f1f !important;
        border-color: #2c2c2c !important;
        color: #d0d2d6 !important;
        &::after { background: #2c2c2c !important; color: #d0d2d6 !important; }
      }

      .v-select .vs__dropdown-toggle { background: #1f1f1f !important; border-color: #2c2c2c !important; }
      .v-select .vs__selected, .v-select .vs__search { color: #d0d2d6; }
      .v-select .vs__dropdown-menu { background: #242424; border-color: #3a3a3a; }
      .v-select .vs__dropdown-option { color: #d0d2d6; }
      .v-select .vs__dropdown-option--highlight { background: #2c2c2c; color: #fff; }

      .table thead th { background: #1f1f1f !important; color: #6e7079 !important; border-bottom-color: #2c2c2c !important; }
      .table tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
      .table tbody tr:hover { background: rgba(59, 130, 246, 0.08) !important; }
    }
</style>